import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-7de94eb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-page" }
const _hoisted_2 = { class: "home-header" }
const _hoisted_3 = { class: "header-logo" }
const _hoisted_4 = { class: "header-menu" }
const _hoisted_5 = { class: "web-content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "footer-text" }, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://beian.miit.gov.cn/#/Integrated/index" }, "粤ICP备2022135121号-1")
    ]),
    /*#__PURE__*/_createElementVNode("p", null, "地址：佛山市禅城区张槎街道智慧路4号二十九座一层101室 电话：18826276898 官网：www.shenshimuseum.com")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onHome && _ctx.onHome(...args))),
          class: "logo",
          src: _imports_0,
          alt: ""
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_menu, {
          class: "menu-box",
          "default-active": _ctx.$route.path,
          mode: "horizontal",
          router: "",
          ellipsis: false
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuList, (item) => {
              return (_openBlock(), _createBlock(_component_el_menu_item, {
                index: item.path,
                key: item.path
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(item.title), 1)
                ]),
                _: 2
              }, 1032, ["index"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["default-active"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
        ]),
        _: 1
      })
    ]),
    _hoisted_6
  ]))
}